import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isOpen: false,
    type: ""
};

const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        openModal: (state, action) => {
            return { ...state, isOpen: true, ...action.payload }
        },
        closeModal: (state) => {
            return { ...initialState }
        },
    },
});

export const { openModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;
